import React, { useEffect } from "react";
import { Spin } from "antd";
import { useApplicationStateValue } from "../../application/Application";
import styled from "styled-components";
import { Flex } from "reflexbox/src";

const StyledContainer = styled(Flex)`
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
`;

const SuccessfulPaymentInterceptor = props => {
    const { confirmPayment } = useApplicationStateValue();

    const dataCallback = props.location.search
        .slice(1)
        .split("&")
        .reduce((obj, row) => {
            const params = row.split("=");
            obj[params[0]] = params[1];
            return obj;
        }, {});

    const indexOfDigest = props.location.search.indexOf("&digest");

    dataCallback["success-url"] = `${window.location.protocol}//${window.location.host}${props.location.pathname}${props.location.search.slice(
        0,
        indexOfDigest
    )}`;

    useEffect(() => {
        confirmPayment(dataCallback);
    }, []);

    return (
        <StyledContainer>
            <Spin />
        </StyledContainer>
    );
};

export default SuccessfulPaymentInterceptor;
